import axios from 'axios'
import qs from 'qs'

import settings from '@/settings/settings.js'

const Http = axios.create({
  baseURL: `${settings.endpoint}`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'comma', skipNulls: true })
  },
})

// Quando o body é FormData, removemos o Content-Type default ('application/json')
// para que o axios/browser auto-detecte e adicione 'multipart/form-data; boundary=...'
// corretamente. Necessário a partir do axios 1.13+, que parou de fazer esse override silencioso.
Http.interceptors.request.use(config => {
  if (config.data instanceof FormData && config.headers) {
    delete config.headers['Content-Type']
  }
  return config
})

export default Http
